import React, { useContext } from 'react';
import DashboardGadgetReportLinkButton from './DashboardGadgetReportLinkButton';
import usePopupCallback from '../../hooks/usePopupCallback';
import DashboardGadgetContext from '../../contexts/DashboardGadgetContext';

const DashboardGadgetReportLinkButtonContainer = () => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);
  const onClick = usePopupCallback(dashboardGadget);
  if (onClick) {
    const testId = `popup-${dashboardGadget.id}`;
    return (
      <DashboardGadgetReportLinkButton onClick={onClick} testId={testId} />
    );
  }
  return null;
};

const RenderGate = () => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);
  if (!dashboardGadget) {
    return null;
  }

  return <DashboardGadgetReportLinkButtonContainer />;
};

export default RenderGate;
